import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Grid, Link, Typography, List, ListItem, Button } from '@mui/material';
import { ITicketOrder, ticketDetailsContext } from '../../TicketDetailsContext';
import { DeleteIconButton, NoResultsTableFooter } from 'components';
import AddOrders from './AddOrders';
import { SearchType } from 'helpers/Enums';
import Moment from 'react-moment';
import { appUserContext } from 'helpers/services';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { MdDelete as DeleteIcon } from 'react-icons/md';


let Orders = () => {
    let { formatMessage } = useIntl();

    let { currentUser, isMobile } = useContext(appUserContext);
    let service = useContext(ticketDetailsContext);

    return (
        <Grid container>
            {isMobile === false &&
                <Grid item xs={12}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{formatMessage({ id: LocalizationIds.WorkOrder })}</TableCell>
                                <TableCell>{formatMessage({ id: LocalizationIds.Order })}</TableCell>
                                <TableCell>{formatMessage({ id: LocalizationIds.Description })}</TableCell>
                                {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                                    <TableCell align="right"></TableCell>
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.selectedOrders.map((order, index) =>
                                <TableRow hover key={index}>
                                    <TableCell>
                                        {order.type === SearchType.WorkOrders &&
                                            <Link target="_blank" href={`${process.env.REACT_APP_CRM_URL}/spa/WorkOrder/${order.workOrderId}`}>
                                                {order.workOrderNumber}
                                            </Link>
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <Link target="_blank" href={`${process.env.REACT_APP_CRM_URL}/spa/Order/${order.orderId}`}>
                                            <Typography variant="body2">
                                                {order.orderType}{order.orderNumber}
                                            </Typography>
                                        </Link>
                                        {order.orderDate &&
                                            <Typography variant="caption">
                                                <Moment date={order.orderDate} format="LL" />
                                            </Typography>
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {order.type === SearchType.Orders && order.orderTitle}
                                        {order.type === SearchType.WorkOrders &&
                                            <>
                                                {order.articleId}&nbsp;{order.articleModel}&nbsp;{order.articleVersion}&nbsp;{order.articleDescription}
                                            </>
                                        }
                                    </TableCell>
                                    {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                                        <TableCell align="right">
                                            <DeleteIconButton onClick={async () => await service.removeOrder(order)} />
                                        </TableCell>
                                    }
                                </TableRow>
                            )}
                        </TableBody>
                        {service.selectedOrders.length === 0 &&
                            <NoResultsTableFooter colSpan={4} message={formatMessage({ id: LocalizationIds.NoSelectedOrders })} />
                        }
                    </Table>
                </Grid>
            }
            {isMobile === true &&
                <List>
                    {service.selectedOrders.map((order, index) =>
                        <ListItem disableGutters divider key={index}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        <b>{formatMessage({ id: LocalizationIds.WorkOrder })}:</b>&nbsp;
                                    </Typography>
                                    {order.type === SearchType.WorkOrders &&
                                        <Link target="_blank" href={`${process.env.REACT_APP_CRM_URL}/spa/WorkOrder/${order.workOrderId}`}>
                                            {order.workOrderNumber}
                                        </Link>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        <b>{formatMessage({ id: LocalizationIds.Order })}:</b>&nbsp;
                                    </Typography>
                                    <Link target="_blank" href={`${process.env.REACT_APP_CRM_URL}/spa/Order/${order.orderId}`}>
                                        <Typography variant="body2">
                                            {order.orderType}{order.orderNumber}
                                        </Typography>
                                    </Link>
                                    {order.orderDate &&
                                        <Typography variant="caption">
                                            <Moment date={order.orderDate} format="LL" />
                                        </Typography>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        <b>{formatMessage({ id: LocalizationIds.Description })}:</b>&nbsp;
                                    </Typography>
                                    <Typography variant="body2">
                                        {order.type === SearchType.Orders && order.orderTitle}
                                        {order.type === SearchType.WorkOrders &&
                                            <>
                                                {order.articleId}&nbsp;{order.articleModel}&nbsp;{order.articleVersion}&nbsp;{order.articleDescription}
                                            </>
                                        }
                                    </Typography>
                                </Grid>
                                {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Button color="secondary"
                                            onClick={async (e: any) => {
                                                e.stopPropagation();
                                                await service.removeOrder(order)
                                            }}
                                        >
                                            <DeleteIcon /> {formatMessage({ id: LocalizationIds.Delete })}
                                        </Button>
                                    </Grid>
                                }
                            </Grid>
                        </ListItem>
                    )}
                </List>
            }

            {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                <AddOrders
                    searchType={service.selectedOrders[0]?.type || ''}
                    customerId={service.ticket.customerId}
                    onSelect={(v: ITicketOrder) => service.addOrder(v)}
                />
            }
        </Grid>
    )
}

export default Orders;